module.exports = __webpack_public_path__ + "img/1466702639.399d8b11.jpg";